import React from 'react'
import Navbar from '../Components/Navbar'
import Hero from '../Components/Hero'
import Footer from '../Components/Footer'
import Work from '../Components/Work'

function Home() {
  return (
    <div>
      <Navbar />
      <Hero />
      <Work />
      <Footer />
    </div>
  )
}

export default Home